// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"ZipwhipSettingsList_contentComponent__3gdNM","tableContainer":"ZipwhipSettingsList_tableContainer__2UGDb","root":"ZipwhipSettingsList_root__1V75L"};